export default __webpack_public_path__ + "static/media/Nespresso-logo.052dd842.svg";